export default __webpack_public_path__ + "static/media/10-gm-achieved.d1d5c7e8.png";